<script setup lang="ts">
import { ref } from 'vue'
import { NButton } from 'naive-ui'

import TalentProfileCard from "@/components/client/home/TalentProfileCard.vue";
import { TalentProfile } from "@/ts/interfaces"

const talents : TalentProfile[] = [
  {
    profilePicLink: "pictures/profile-picture-Rafael.png",
    name: "Rafael",
    // profileLink: "https://www.google.com/",
    mainSkills: ["OOP", "Full stack Application", "C++"],
    yearsOfExperience: 14,
    location: "Brazil",
    hourlyRate: 60,
    about: "Experienced Software Engineer with a demonstrated history of working in the information technology and services industry. Skilled in OOP, Full Stack applications, C#, JS. Strong engineering professional with a Doctor of Philosophy - Ph.D. in Computer Engineering.",
    complementarySkills: ["Net Core", "Python", "NodeJS"],
    experience: [
      {
        job_position: "Team Lead Software Development",
        time_period: "July 2018 - Present"
      },
      {
        job_position: "Lead Developer",
        time_period: "February 2017 - June 2018"
      },
      {
        job_position: "Full-Stack Developer",
        time_period: "February 2012 - January 2017"
      },
      {
        job_position: "Mobile & Full-Stack Developer",
        time_period: "September 2010 - January 2011"
      }
    ]
  },
  {
    profilePicLink: "pictures/profile-picture-Tania.png",
    name: "Tania",
    // profileLink: "https://www.google.com/",
    mainSkills: ["Typescript", "Javascript", "ES2020"],
    yearsOfExperience: 12,
    location: "México",
    hourlyRate: 50,
    about: "Experienced Software Engineer with a demonstrated history of working in the information technology and services industry. Skilled in OOP, Full Stack applications, C#, JS. Strong engineering professional with a Doctor of Philosophy - Ph.D. in Computer Engineering.",
    complementarySkills: ["Net Core", "Python", "NodeJS"],
    experience: [
      {
        job_position: "Team Lead Software Development",
        time_period: "July 2018 - Present"
      },
      {
        job_position: "Lead Developer",
        time_period: "February 2017 - June 2018"
      },
      {
        job_position: "Full-Stack Developer",
        time_period: "February 2012 - January 2017"
      },
      {
        job_position: "Mobile & Full-Stack Developer",
        time_period: "September 2010 - January 2011"
      }
    ]
  },
  {
    profilePicLink: "pictures/profile-picture-Marcos.png",
    name: "Marcos",
    // profileLink: "https://www.google.com/",
    mainSkills: ["Javascript", "Node.js", "Wordpress"],
    yearsOfExperience: 9,
    location: "México",
    hourlyRate: 50,
    about: "Experienced Software Engineer with a demonstrated history of working in the information technology and services industry. Skilled in OOP, Full Stack applications, C#, JS. Strong engineering professional with a Doctor of Philosophy - Ph.D. in Computer Engineering.",
    complementarySkills: ["Net Core", "Python", "NodeJS"],
    experience: [
      {
        job_position: "Team Lead Software Development",
        time_period: "July 2018 - Present"
      },
      {
        job_position: "Lead Developer",
        time_period: "February 2017 - June 2018"
      },
      {
        job_position: "Full-Stack Developer",
        time_period: "February 2012 - January 2017"
      },
      {
        job_position: "Mobile & Full-Stack Developer",
        time_period: "September 2010 - January 2011"
      }
    ]
  }
]

const cardExpanded = ref<null | number>(null)
const expandCard = (key: number) => cardExpanded.value = key

const closeCard = () => cardExpanded.value = null

const cardIsHidden = (key: number) => cardExpanded.value !== null && (key !== cardExpanded.value)
</script>

<template>
  <section class="meet-our-talent">
    <h2 class="body-text-lg text-w-bold title">
      Meet our talent
    </h2>
    <p class="body-text body">
      Here’s a sample of the amazing talent you Augment your team with
      Submit a project request to access a pool of candidates based on your requirements.
    </p>

    <div class="profile-cards-container grid-x">
      <div class="cell small-12 medium-6" :class="cardExpanded != null ? 'large-12' : 'large-4'" v-for="(talent, key) in talents" :key="key">
        <talent-profile-card v-show="!cardIsHidden(key)" v-bind="talent" :is-expanded="key === cardExpanded" @expand-card="expandCard(key)" @close-card="closeCard"></talent-profile-card>
      </div>
    </div>

    <div class="grid-x align-center new-project-button-container">
      <div class="cell small-12 medium-3 large-5 xlarge-6 xxlarge-4 x3large-3">
        <router-link :to="{ name: 'client-project-create' }">
          <n-button class="new-project-button" size="large">
            SUBMIT NEW PROJECT
          </n-button>
        </router-link>
      </div>
    </div>

  </section>
</template>

<style lang="scss">
.meet-our-talent {
  .title {
    margin-bottom: 24px;
  }

  .body {
    margin-bottom: 24px;
  }

  .profile-cards-container {

  }

  .profile-cards-container {
    //gap: 28px;
    //flex-wrap: nowrap;
  }

  .new-project-button {
    margin-top: 25px;
  }
}

</style>